import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { ITableColumn } from "src/app/shared/components/tables/datatable/datatable.component";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";


export const SUBMISSION_ENDPOINT = 'files';
export const SUBMISSION_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(SUBMISSION_ENDPOINT);


export const submissionStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const LISTA_SUBMISSION_COLUMNS: any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'outcome',
    label: 'Esito',
    field: 'outcome',
    type:'text'
  },
  {
    name: 'practiceNumber',
    label: 'Numero Pratica',
    field: 'practiceNumber',
    type:'text'
  },
  {
    name: 'psaName',
    label: 'Nome PSA',
    field: 'psaName',
    type:'text'
  },
  {
    name: 'state',
    label: 'Stato',
    field: 'state',
    type:'text'
  },
  {
    name: 'step',
    label: 'Stato',
    field: 'step',
    type:'text'
  },
  {
    name: 'submittedAt',
    label: 'Trasmesso il',
    field: 'submittedAt',
    type: 'date',
  },
  {
    name: 'updatedAt',
    label: 'Aggiornato il',
    field: 'updatedAt',
    type: 'date',
  },
];

export const LISTA_SUBMISSION_VISIBLECOLUMNS = [
  'practiceNumber',
  'psaName',
  'step',
  'outcome',
  'submittedAt',
  'updatedAt',
  'azioni'
];


export const LISTA_SUBMISSION_FILTER_COLUMNS: ITableColumn[] = [
  {
    name: 'status.name',
    label: 'Stato',
    field: 'status.name',
    type:'select',
    options: [
      {
        id: 'ESITO_ASSEGNATO',
        name: 'Giudizio emesso',
      }
    ]
  },
];

